import { useState, useMemo } from "react";
import { SearchCriteria } from "../types/search";

interface UseSearchReturn {
  searchCriteria: SearchCriteria;
  handleSearch: (criteria: SearchCriteria) => void;
  clearAllSearch: () => void;
  hasActiveSearch: boolean;
}

export const useSearch = (): UseSearchReturn => {
  const [searchCriteria, setSearchCriteria] = useState<SearchCriteria>({
    patientFirstName: "",
    patientLastName: "",
    patientDateOfBirth: "",
    patientExternalId: "",
  });

  const hasActiveSearch = useMemo(() => {
    return !!(
      searchCriteria.patientFirstName.trim() ||
      searchCriteria.patientLastName.trim() ||
      searchCriteria.patientDateOfBirth.trim() ||
      searchCriteria.patientExternalId.trim()
    );
  }, [searchCriteria]);

  const handleSearch = (criteria: SearchCriteria) => {
    setSearchCriteria(criteria);
  };

  const clearAllSearch = () => {
    setSearchCriteria({
      patientFirstName: "",
      patientLastName: "",
      patientDateOfBirth: "",
      patientExternalId: "",
    });
  };

  return {
    searchCriteria,
    handleSearch,
    clearAllSearch,
    hasActiveSearch,
  };
};
